import { Component, OnInit } from '@angular/core';
import { Sidebar2SubpanelStateService } from '../../sidebar2-subpanel-state.service';

@Component({
    selector: 'app-sidebar2-contacts-sub-menu',
    templateUrl: './sidebar2-contacts-sub-menu.component.html',
    standalone: false,
})
export class Sidebar2ContactsSubMenuComponent implements OnInit {
    statuses = [];
    constructor(private subpanelService: Sidebar2SubpanelStateService) {}

    ngOnInit() {
        this.subpanelService.getContactsPromise().then((res) => {
            this.statuses = res;
        });
    }
}
